module.exports = "https://static.wmbcdn.com/uniweb/images/4f8a82e59183740c725b239eacab5023.svg";